var HEADER_SUBNAV_ALIGNMENTS = ['left', 'right'];

export { HEADER_SUBNAV_ALIGNMENTS };
